exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-emailLayout-BodyContent-textArea{width:100%;white-space:pre-wrap;height:350px;overflow-y:auto;border:2px solid #b3b3b3 !important;border-radius:0 !important}", ""]);

// exports
exports.locals = {
	"textArea": "src-components-emailLayout-BodyContent-textArea"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/emailLayout/BodyContent/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/emailLayout/BodyContent/styles.scss
// module chunks = 1